<script>
	export let list;
	import timerIcon from "./video_time_icon.png";
	export let everyListNum;
	export let cardWidth;
	export let isLoading;
	import {protalRead} from '$api'
	import Loading from './Loading.svelte';
	var handleClick = function (item) {
		protalRead({id: item.id, name: item.title})
		window.open(item.link);
	};
</script>

<style>
	.video-list .video-item {
		display: inline-block;
		margin-right: 16px;
		cursor: pointer;
	}
	.video-list .video-item:hover .video-info .title::before {
		content: "";
		position: absolute;
		left: 0px;
		right: 0px;
		bottom: 0px;
		height: 2px;
		background: linear-gradient(#cad2f0, #a5b2ec);
	}
	.video-list .video-item.lineEnd {
		margin-right: 0px;
		margin-bottom: 16px;
	}
	.video-list .video-item .video-info {
		text-align: left;
		color: #006bbd;
		position: relative;
		line-height: 30px;
	}
	.video-list .video-item .video-info .title {
		text-align: left;
		color: #006bbd;
		position: relative;
		display: inline-block;
		max-width: 290px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	.video-list .video-item .video-info .time {
		float: right;
		color: #2e2e2e;
	}
	.video-list .video-item .video-info .time img{
		padding-right: 8px;
	}
</style>
{#if isLoading === true}
	<Loading></Loading>
{/if}
<div class="video-list" aecore-fe-index="video-list">
	{#each list as item, index}
		<div
			on:click={() => handleClick(item)}
			class={'video-item ' + ((index + 1) % everyListNum === 0 ? 'lineEnd' : '')}>
			<div class="picture">
				<img
					width={cardWidth}
					alt="video-thumb"
					height="230px"
					src={item.thumb} />
			</div>
			<div class="video-info">
				<span class="title">{item.title}</span>
				<span class="time"><img
						src={timerIcon}
						alt="timericon" />{item.unitCount + item.unitName}</span>
			</div>
		</div>
	{/each}
</div>
